import { render, staticRenderFns } from "./ShippingSearch.vue?vue&type=template&id=362560b5&scoped=true&"
import script from "./ShippingSearch.vue?vue&type=script&lang=js&"
export * from "./ShippingSearch.vue?vue&type=script&lang=js&"
import style0 from "./ShippingSearch.vue?vue&type=style&index=0&id=362560b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362560b5",
  null
  
)

export default component.exports